export const SET_EXIT_SURVEY = "SET_EXIT_SURVEY";

export default function(exitSurveyType) {
  return dispatch =>
    dispatch({
      type: SET_EXIT_SURVEY,
      payload: exitSurveyType
    });
}
